import colors from '../theme/colors';

const styles = {
  empty: () => ({
    textAlign: "center",
    padding: 12,
  }),
  load: () => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: '#F4F3EF'
  }),
  user: () => ({
    float: "right",
  }),
  layout: (isAuthenticated) => ({
    // height: "100%",
    backgroundColor: '#f4f3ef',// colors.SENSIKA,
    fontFamily: 'Montserrat'
  }),
};

export default styles;
